/** Process kinds for fleet / bridge operation logs. */
export type FleetProcessKind = 'host_provision' | 'agent_install';

export type BridgeInstalledAgentStatus = 'pending' | 'installing' | 'ready' | 'failed';

export type BridgeInstalledAgentRow = {
  agentId: string;
  bridgeId: string;
  agentType: string;
  status: BridgeInstalledAgentStatus;
  installProcessId: string | null;
  hasAuthToken: boolean;
  createdAt: string;
  updatedAt: string;
};

export type AgentInstallEventType =
  | 'agent_install_started'
  | 'agent_install_auth_configured'
  | 'agent_install_scheduled'
  | 'agent_install_package'
  | 'agent_install_detected'
  | 'agent_install_completed'
  | 'agent_install_failed';

export type BridgeProcessEventRow = {
  eventId: number;
  processId: string;
  processKind: FleetProcessKind;
  eventType: AgentInstallEventType;
  detail: Record<string, unknown> | null;
  createdAt: string;
};

export type InstallableBridgeAgent = {
  value: string;
  label: string;
  tokenLabel: string;
  tokenEnvVar: string;
};

export const INSTALLABLE_BRIDGE_AGENTS: InstallableBridgeAgent[] = [
  { value: 'claude-code', label: 'Anthropic Claude Code', tokenLabel: 'Anthropic API key', tokenEnvVar: 'ANTHROPIC_API_KEY' },
  { value: 'codex-acp', label: 'Codex', tokenLabel: 'OpenAI API key', tokenEnvVar: 'OPENAI_API_KEY' },
  { value: 'cursor-cli', label: 'Cursor CLI agent', tokenLabel: 'Cursor API key', tokenEnvVar: 'CURSOR_API_KEY' },
  { value: 'opencode', label: 'OpenCode agent', tokenLabel: 'Provider API key', tokenEnvVar: 'OPENCODE_API_KEY' },
];
